import { render, staticRenderFns } from "./AlwaysStatistic.vue?vue&type=template&id=5f462bde&scoped=true&"
import script from "./AlwaysStatistic.vue?vue&type=script&lang=js&"
export * from "./AlwaysStatistic.vue?vue&type=script&lang=js&"
import style0 from "./AlwaysStatistic.vue?vue&type=style&index=0&id=5f462bde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f462bde",
  null
  
)

export default component.exports